var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsSkDelivery = function SvgNnIconFlagsSkDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-SK-delivery_svg__Lager_52",
    "data-name": "Lager 52",
    viewBox: "0 0 50.47 33.81"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nn-icon-flags-SK-delivery_svg__clip-path",
    transform: "translate(-24.77 -33.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.57 58.33c-2.73-1.32-6.65-3.94-6.65-9.12s.24-7.54.24-7.54H49s.25 2.36.25 7.54-3.94 7.79-6.68 9.12",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-SK-delivery_svg__cls-2{fill:red}.nn-icon-flags-SK-delivery_svg__cls-4{fill:#0062d9}.nn-icon-flags-SK-delivery_svg__cls-5{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    className: "nn-icon-flags-SK-delivery_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.25.25h49.97v22.21H.25z",
    className: "nn-icon-flags-SK-delivery_svg__cls-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.25.25h49.97v11.1H.25z",
    className: "nn-icon-flags-SK-delivery_svg__cls-5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-SK-delivery_svg__coa",
    d: "M42.57 59.08c-3-1.44-7.25-4.3-7.25-9.94s.27-8.22.27-8.22h14s.27 2.57.27 8.22-4.3 8.5-7.29 9.94",
    className: "nn-icon-flags-SK-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-SK-delivery_svg__coa-2",
    d: "M42.57 58.33c-2.73-1.32-6.65-3.94-6.65-9.12s.24-7.54.24-7.54H49s.25 2.36.25 7.54-3.94 7.79-6.68 9.12",
    className: "nn-icon-flags-SK-delivery_svg__cls-2",
    "data-name": "coa",
    transform: "translate(-24.77 -33.09)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.87 14.36a10.8 10.8 0 0 1-3.48.39v-1.84a8.4 8.4 0 0 1 2.75.4s0-.46 0-1v-1a8.4 8.4 0 0 1-2.75.4 16.6 16.6 0 0 1 .37-2.58s-.68.06-1 .06-1-.06-1-.06a16 16 0 0 1 .47 2.62 8.3 8.3 0 0 1-2.74-.4s0 .46 0 1v1a8.4 8.4 0 0 1 2.74-.44v1.8a10.8 10.8 0 0 1-3.48-.39s0 .46 0 1v1a11.1 11.1 0 0 1 3.48-.4v2.86h1.17v-2.82a11.1 11.1 0 0 1 3.48.4s0-.47 0-1-.01-1-.01-1",
    className: "nn-icon-flags-SK-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m42.45 60-5.67-5s.72-2.35 2.14-2.35a1.71 1.71 0 0 1 1.54.91s.73-1.91 2.11-1.91 2.12 1.91 2.12 1.91a1.69 1.69 0 0 1 1.54-.91c1.42 0 2.14 2.35 2.14 2.35z",
    className: "nn-icon-flags-SK-delivery_svg__cls-4",
    style: {
      clipPath: "url(#nn-icon-flags-SK-delivery_svg__clip-path)"
    },
    transform: "translate(-24.77 -33.09)"
  }));
};
export default SvgNnIconFlagsSkDelivery;